import { useEffect, useRef } from "react"
import { usePage } from "@inertiajs/react"
import { toast } from "sonner"

interface FlashData {
  notice?: string
  alert?: string
  timestamp?: number
}

export function FlashMessages() {
  const { flash } = usePage<{ flash: FlashData }>().props
  const shownRef = useRef<Set<string>>(new Set())

  useEffect(() => {
    const ts = flash?.timestamp || Date.now()

    if (flash?.notice) {
      const key = `notice:${flash.notice}:${ts}`
      if (!shownRef.current.has(key)) {
        shownRef.current.add(key)
        toast.success(flash.notice)
      }
    }

    if (flash?.alert) {
      const key = `alert:${flash.alert}:${ts}`
      if (!shownRef.current.has(key)) {
        shownRef.current.add(key)
        toast.error(flash.alert)
      }
    }
  }, [flash])

  return null
}
